const loading = (action: 'show'|'hide') => {
    const preloader: string|null|HTMLElement = document.getElementById('preloader')
    const statusLoader: string|null|HTMLElement = document.getElementById('status')

    if (preloader) {
        preloader.style.display = action === 'show' ? 'block' : 'none'
    }

    if (statusLoader) {
        statusLoader.style.display = action === 'show' ? 'block' : 'none'
    }
}

export default loading
